import { useEffect, useState } from "react";

export function useRetryAfter() {
   const [retryAfterDate, setRetryAfterDate] = useState<Date>();
   const [retryAfter, setRetryAfter] = useState<number>(0);
   useEffect(() => {
      if (retryAfterDate) {
         const retryAfterTimestamp = retryAfterDate.getTime();
         const iteration = () => {
            const now = new Date();
            const diff = retryAfterTimestamp - now.getTime();
            if (diff <= 0) {
               setRetryAfter(0);
               setRetryAfterDate(undefined);
               clearInterval(interval);
            } else {
               setRetryAfter(Math.ceil(diff / 1000));
            }
         };
         iteration();

         const interval = setInterval(iteration, 1000);

         return () => clearInterval(interval);
      }
   }, [retryAfterDate]);

   return { retryAfterDate, setRetryAfterDate, retryAfter };
}